import React from "react";
import { CircleBtn, CircleBtnType } from "../../../../../../../react-core/Html/CircleBtn";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { IAddClientModel } from "../AddClientWizard";

interface IFATCACountryProps extends IProcessComponentProps {
    data: IAddClientModel;
    onChangeFromOrganisationDetailTab?: Function;
    disable?: boolean;
}

interface IFATCACountryState {}

export class FATCACountry extends ProcessComponent<IFATCACountryProps, IFATCACountryState> {
    constructor(props: IFATCACountryProps) {
        super(props);
        this.state = {
            AddAnotherTaxResidency: false,
        };
    }

    render() {
        const { data, onChange, onChangeFromOrganisationDetailTab, disable } = this.props;
        return (
            <>
                {data?.Organisation?.FatcaCountries?.map((item, index) => {
                    return (
                        <>
                            <SelectEditor
                                options={CountryCodeMap.getArray()}
                                getText={(v) => {
                                    return CountryCodeMap.getString(v);
                                }}
                                cssWrapper="control-size-430"
                                placeholder="Please select"
                                label="Country of Tax Residency"
                                selected={item?.CountryOfTaxResidency}
                                onChange={(v) => {
                                    const _data = data?.Organisation?.FatcaCountries.concat();
                                    _data[index].CountryOfTaxResidency = v;
                                    if (this.props.onChangeFromOrganisationDetailTab) {
                                        onChangeFromOrganisationDetailTab(_data);
                                    } else {
                                        onChange(_data);
                                    }
                                }}
                                validationRules={[
                                    {
                                        errorMessage: "Can not add same tax residency twice",
                                        validator: (v) => {
                                            if (!v) {return true;}
                                            return (
                                                data?.Organisation?.FatcaCountries.filter(
                                                    (x) => x.CountryOfTaxResidency == v
                                                )?.length < 2
                                            );
                                        },
                                    },
                                ]}
                                required="Please select"
                                disabled={disable}
                            />
                            <TextBoxEditor
                                cssWrapper="control-size-430"
                                value={item?.TaxIdentificationNumber}
                                label={"Tax identification number"}
                                maxLength={35}
                                onChange={(v) => {
                                    const _data = data?.Organisation?.FatcaCountries.concat();
                                    _data[index].TaxIdentificationNumber = v;
                                    if (this.props.onChangeFromOrganisationDetailTab) {
                                        onChangeFromOrganisationDetailTab(_data);
                                    } else {
                                        onChange(_data);
                                    }
                                }}
                                required={"Please enter"}
                                disabled={disable}
                            />
                            {index != 4 && data?.Organisation?.FatcaCountries?.length == index + 1 && !disable && (
                                <CircleBtn
                                    type={CircleBtnType.add}
                                    title="Add another tax residency"
                                    onClick={() => {
                                        if (this.isValid()) {
                                            const _data = data?.Organisation?.FatcaCountries.concat({});
                                            if (this.props.onChangeFromOrganisationDetailTab) {
                                                onChangeFromOrganisationDetailTab(_data);
                                            } else {
                                                onChange(_data);
                                            }
                                        }
                                    }}
                                />
                            )}
                            {(index != 0 || data?.Organisation?.FatcaCountries?.length > 1) && !disable && (
                                <CircleBtn
                                    type={CircleBtnType.remove}
                                    title="Remove tax residency"
                                    onClick={() => {
                                        const _data = data?.Organisation?.FatcaCountries.concat();
                                        _data.splice(index, 1);
                                        if (this.props.onChangeFromOrganisationDetailTab) {
                                            onChangeFromOrganisationDetailTab(_data);
                                        } else {
                                            onChange(_data);
                                        }
                                    }}
                                />
                            )}
                        </>
                    );
                })}
            </>
        );
    }
}
